import { useEffect, useState } from 'react';
import { ProfileEditAjaxEndPoints } from '../../profile/ProfileEditAjaxEndPoints.ts';
export const useEditProfileInfo = (open)=>{
    const [info, setInfo] = useState(undefined);
    useEffect(()=>{
        if (!open) return;
        let cancelled = false;
        const loadInfo = async ()=>{
            const data = await ProfileEditAjaxEndPoints.getEditProfileInfo();
            if (cancelled) return;
            if (data == undefined) return;
            setInfo(data);
        };
        void loadInfo();
        return ()=>{
            cancelled = true;
        };
    }, [
        open
    ]);
    return info;
};
